import type { RouteRecordRaw } from 'vue-router'

export const userManagementRoutes: RouteRecordRaw[] = [
  {
    path: 'user-management',
    component: () => import('@/modules/UserManagement/layout/UserManagementLayout.vue'),
    meta: { title: 'User Management', requiresAuth: true },
    children: [
      {
        path: '',
        redirect: { name: 'UserManagementMasters' }
      },
      {
        path: 'masters',
        name: 'UserManagementMasters',
        component: () => import('@/modules/UserManagement/masters/UserManagementMaster.vue'),
        meta: { title: 'Masters', requiresAuth: true, breadcrumb: 'Masters' }
      },
      {
        path: 'organisation-config',
        name: 'OrganisationConfig',
        component: () => import('@/modules/UserManagement/masters/organisationConfig/components/OrganisationConfig.vue'),
        meta: { title: 'Organization Config', requiresAuth: true, breadcrumb: 'Organization Config' }
      },
      {
        path: 'location-master',
        name: 'LocationMasterList',
        component: () => import('@/modules/UserManagement/masters/locationMaster/components/LocationMasterList.vue'),
        meta: { title: 'Location Master', requiresAuth: true, breadcrumb: 'Location Master' }
      },
      {
        path: 'location-master/form',
        name: 'LocationMasterForm',
        component: () => import('@/modules/UserManagement/masters/locationMaster/components/LocationMasterForm.vue'),
        meta: { title: 'Location Master Form', requiresAuth: true, breadcrumb: 'Location Master Form' }
      },
      {
        path: 'location-type',
        name: 'LocationTypeList',
        component: () => import('@/modules/UserManagement/masters/locationType/components/LocationTypeList.vue'),
        meta: { title: 'LocationType Master', requiresAuth: true, breadcrumb: 'LocationType Master' }
      },
      {
        path: 'location-type/form',
        name: 'LocationTypeForm',
        component: () => import('@/modules/UserManagement/masters/locationType/components/LocationTypeForm.vue'),
        meta: { title: 'LocationType Form', requiresAuth: true, breadcrumb: 'LocationType Form' }
      },
      {
        path: 'department/form',
        name: 'DepartmentForm',
        component: () => import('@/modules/UserManagement/masters/department/components/DepartmentForm.vue'),
        meta: { title: 'Department Form', requiresAuth: true, breadcrumb: 'Department Form' }
      },
      {
        path: 'code-template',
        name: 'CodeTemplate',
        component: () => import('@/modules/UserManagement/masters/codeTemplate/components/CodeTemplate.vue'),
        meta: { title: 'Code Template', requiresAuth: true, breadcrumb: 'Code Template' }
      },
      {
        path: 'approval',
        name: 'ApprovalList',
        component: () => import('@/modules/UserManagement/masters/approval/components/ApprovalList.vue'),
        meta: { title: 'Approval', requiresAuth: true, breadcrumb: 'Approval' }
      },
      {
        path: 'rule-master',
        name: 'RuleMasterList',
        component: () => import('@/modules/UserManagement/masters/ruleMaster/components/RuleMasterList.vue'),
        meta: { title: 'Rule Master', requiresAuth: true, breadcrumb: 'Rule Master' }
      },
      {
        path: 'rule-master/form',
        name: 'RuleMasterForm',
        component: () => import('@/modules/UserManagement/masters/ruleMaster/components/RuleMasterForm.vue'),
        meta: { title: 'Rule Master Form', requiresAuth: true, breadcrumb: 'Rule Master Form' }
      },
      {
        path: 'news-events',
        name: 'NewsEventsList',
        component: () => import('@/modules/UserManagement/masters/newsEvents/components/NewsEventsList.vue'),
        meta: { title: 'News & Events', requiresAuth: true, breadcrumb: 'News & Events' }
      },
      {
        path: 'roles/create',
        name: 'RoleCreate',
        component: () => import('@/modules/UserManagement/rolesAndPermissions/components/RoleFormPage.vue'),
        meta: { title: 'Create Role', requiresAuth: true, breadcrumb: 'Create Role' }
      },
      {
        path: 'roles/:id/edit',
        name: 'RoleEdit',
        component: () => import('@/modules/UserManagement/rolesAndPermissions/components/RoleFormPage.vue'),
        meta: { title: 'Edit Role', requiresAuth: true, breadcrumb: 'Edit Role' }
      }
    ]
  }
]
